import React, { useState, useContext } from 'react';
import { PermissionsContext } from 'context';
import Locales from 'locales';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogDescription,
} from 'components/ui/alert-dialog';

export const LockProtection = (WrappedComponent) => {
  const Component = (props) => {
    const { protected: isProtected = true, bypassLock = false, onClick, onSelect, ...rest } = props;

    const { isPlatformLocked, isManualLocked, isRegistrationEnd, isQuotaReached } = useContext(PermissionsContext);
    const [open, setOpen] = useState(false);

    const isDropdownItem =
      WrappedComponent.displayName === 'DropdownMenuItem' ||
      WrappedComponent.name === 'DropdownMenuItem' ||
      WrappedComponent.displayName === 'DropdownMenu.Item' ||
      WrappedComponent.displayName === 'Item' ||
      !!onSelect;

    const handleAction = (e) => {
      if (isProtected && isPlatformLocked && !bypassLock) {
        e.preventDefault();
        setOpen(true);
        return;
      }

      if (isDropdownItem) onSelect?.(e);
      else onClick?.(e);
    };

    return (
      <>
        {isDropdownItem && <WrappedComponent {...rest} onSelect={handleAction} />}

        {!isDropdownItem && <WrappedComponent {...rest} onClick={handleAction} />}

        <AlertDialog open={open} onOpenChange={setOpen}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{Locales.base.access_denied.title}</AlertDialogTitle>
              <AlertDialogDescription>
                {isManualLocked
                  ? Locales.base.access_denied.manual
                  : isRegistrationEnd
                  ? Locales.base.access_denied.registration_end
                  : isQuotaReached
                  ? Locales.base.access_denied.quota_reached
                  : null}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogAction
                className="bg-hajj-primary hover:bg-hajj-secondary text-white rounded-sm  shadow-lg shadow-hajj-primary/20 hover:shadow-xl hover:shadow-hajj-primary/30"
                onClick={() => setOpen(false)}
              >
                OK !
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </>
    );
  };

  Component.displayName = `LockProtection(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return Component;
};
